import React from 'react';
import Card from '@dashboard/components/Card';
import CardHeader from '@dashboard/components/CardHeader';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import CardContent from '@dashboard/components/CardContent';
import SettingsDescription from '@dashboard/components/SettingsDescription';
import { Form } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import Link from '@dashboard/components/Link/Link';
import SettingsContainer from '@/dashboard/components/SettingsContainer';

const SettingsCartAbandonment = () => {
  const { seller } = useAuth();
  const { updateSeller } = useSellerQueries();

  return (
    <Card variant="root">
      <CardHeader variant="root">
        <div className="flex flex-col max-w-lg">
          <CardHeaderTitle variant="root">Cart abandonment</CardHeaderTitle>
          <SettingsDescription className="mt-2">
            Recover lost sales by saving order details and sending a email reminder sequence when a
            checkout is abandoned.{' '}
            <Link href="/help/articles/cart-abandonment" color="default" blank>
              Learn more
            </Link>
          </SettingsDescription>
        </div>
      </CardHeader>

      <CardContent variant="root" className="mb-32">
        <SettingsContainer size="lg">
          <SettingsDescription className="mb-4">
            You can customize email templates and disable reminder emails in each page's After
            payment settings.
          </SettingsDescription>

          <Form
            enableReinitialize
            initialValues={{
              checkoutAbandonment: seller.checkoutAbandonment || {
                collectEmails: false,
                sendEmails: false,
              },
            }}
            fields={({ values, setFieldValue }) => [
              {
                name: 'checkoutAbandonment.collectEmails',
                required: false,
                type: 'checkbox',
                label: 'Save customer contact details',
                tooltip:
                  "Store the customer's contact details when they leave without finishing checkout. Check local regulations before enabling.",
                onChange: e => {
                  const isChecked = e.target.checked;
                  setFieldValue('checkoutAbandonment.collectEmails', isChecked);
                  // Auto-uncheck sendEmails when collectEmails is unchecked
                  if (!isChecked) {
                    setFieldValue('checkoutAbandonment.sendEmails', false);
                  }
                },
              },
              {
                name: 'checkoutAbandonment.sendEmails',
                required: false,
                type: 'checkbox',
                label: 'Send checkout reminder emails',
                tooltip: 'Automatically email customers a link to complete their order.',
                disabled: !values.checkoutAbandonment?.collectEmails,
                inset: true,
                className: !values.checkoutAbandonment?.collectEmails
                  ? 'opacity-50 cursor-not-allowed'
                  : '',
              },
            ]}
            onSubmit={async values => {
              try {
                const { data } = await updateSeller(values);

                return {
                  data,
                };
              } catch (error) {
                return {
                  error,
                };
              }
            }}
          />
        </SettingsContainer>
      </CardContent>
    </Card>
  );
};

export default SettingsCartAbandonment;
